export class StringUtils {
  public static insertStrAt(str: string, insertion: string, position: number): string {
    if (position === 0) {
      return insertion + str;
    }

    if (position >= str.length) {
      return str + insertion;
    }

    return str.substring(0, position) + insertion + str.substring(position);
  }

  public static stripNonDigits(str: string): string {
    if (!str) {
      return '';
    }

    let stripped = '';

    for (let i = 0; i < str.length; i++) {
      if (str.charAt(i).search(/[0-9]/) !== -1) {
        stripped = stripped + str.charAt(i);
      }
    }

    return stripped;
  }

  public static substrCount(haystack: string, needle: string): number {
    if (!haystack) {
      return 0;
    }

    if (!needle) {
      return haystack.length;
    }

    if (needle.length > haystack.length) {
      return 0;
    }

    let count = 0;
    let index = haystack.indexOf(needle);

    while (index !== -1) {
      index = haystack.indexOf(needle, index);

      if (index === -1) {
        break;
      } else {
        count++;
        index++;
      }
    }

    return count;
  }

  public static extractHostPortAndPath(str: string): string {
    let beginIndex = str.indexOf('://');
    beginIndex = beginIndex === -1 ? 0 : beginIndex + 3;

    let endIndex = str.indexOf('?', beginIndex === 0 ? 0 : beginIndex + 1);
    endIndex = endIndex === -1 ? str.length : endIndex;

    return str.substring(beginIndex, endIndex);
  }
}
